import {ScheduleRouteModel} from "site-apps/distribution/schedules/ScheduleModels";



const generateRoutesForRange = (items, routesIds) => {
    if (!items.length) return [];
    const generatedEvents = [];
    items.forEach(route => {
        let schedule = new ScheduleRouteModel(route);
        let run = new Date(schedule.start)
        let idEvent = (route.programming_id || 0) + "-" + route.route_id + "-" + route.type;
        idEvent += "-" + Math.floor(run.getTime() / 1000);
        routesIds.push(idEvent);
        generatedEvents.push(new ScheduleRouteModel(route));
    })
    return generatedEvents;
};

export default generateRoutesForRange;
